import { NotificationType } from "./dispatchNotification";

const addNotificationContent = (
  msg: string,
  variant: NotificationType
): {
  id: number;
  variant: NotificationType;
  message: string;
  autoTimeout: boolean;
} => ({
  id: new Date().getUTCMilliseconds(),
  variant,
  message: msg,
  autoTimeout: true
});

export default addNotificationContent;
